import React, { useState } from 'react'
import Datepicker from "react-tailwindcss-datepicker";
import { post } from '../../util/request';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const AddRencanaIzin = () => {
	const jwtToken = useSelector(state => state.auth.generateToken)
	const user = useSelector(state => state.auth.user)
	const navigate = useNavigate()
	const [state, setState] = useState({
		date1: {
			startDate: null,
			endDate: null
		},
		date2: {
			startDate: null,
			endDate: null
		},
		tipeRencana: '',
		totalHari: '',
		reason: '',
		checklist: false
	})

	const handleValueChange = (e, name) => {
		if (name === "date1" || name === "date2") {
			setState({
				...state,
				[name]: e
			})
			if (name === "date1") {
				getAttendanceSummary(state.totalHari, e.startDate)
			}
		} else {
			setState({
				...state,
				[name]: e.target.value
			})
			if (name === "totalHari") {
				getAttendanceSummary(e.target.value, state.date1.startDate)
			}
		}

	}

	const handleOnChange = () => {
		setState({
			...state,
			checklist: !state.checklist
		})
	};

	const getAttendanceSummary = (days_count, startDate) => {
		post(
			`public/api/v1/member/attendance/absence_request_get_end_date`,
			{
				headers: {
					Authorization: `Bearer ${jwtToken}`,
					'Content-Type': 'application/json'
				},
			},
			{
				company_id: user.company_id,
				ar_employee_id: user.employee_id,
				days_count: days_count,
				ar_start_date: startDate
			},
			success => {
				setState(prevState => {
					return {
						...prevState,
						date2: {
							startDate: success.data.Data.dateDetail[success.data.Data.dateDetail.length - 1],
							endDate: success.data.Data.dateDetail[success.data.Data.dateDetail.length - 1]
						}
					}
				})
			},
			error => {
				setState(prevState => {
					return {
						...prevState,
						loading: false
					}
				})
				console.log('error request', error)
			}
		)
	}

	const setAddIzin = () => {
		var data = {
			days_count: state.totalHari,
			ar_employee_id: user.employee_id,
			company_id: user.company_id,
			ar_start_date: state.date1.startDate,
			ar_end_date: state.date2.endDate,
			ar_reason: state.reason,
			ar_type: state.tipeRencana,

		}
		post(
			`public/api/v1/member/attendance/absence_request`,
			{
				headers: {
					Authorization: `Bearer ${jwtToken}`,
					'Content-Type': 'application/json'
				},
			},
			data,
			success => {
				navigate('/rencana-izin')
			},
			error => {
				setState(prevState => {
					return {
						...prevState,
						loading: false
					}
				})
				console.log('error request', error)
			}
		)
	};
	return (
		<div className='w-full h-screen grid-cols-1 sm:grid-cols-2 bg-real-white'>
			<div className='w-full h-20 bg-real-white'>
				<div className='flex items-center h-full px-4'>
					<a href={process.env.PUBLIC_URL + "/rencana-izin"}>
						<img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
					</a>
					<p className='px-4'>Membuat Jadwal</p>
				</div>
			</div>
			<div className='w-full px-4 bg-real-white'>
				<div className='w-full h-full py-4'>
					<select id="countries" onChange={(e) => handleValueChange(e, 'tipeRencana')} value={state.tipeRencana} class="bg-bg-primary border border-bg-primary text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4 dark:focus:ring-blue-500 dark:focus:border-blue-500">
						<option value={''}>Tipe Rencana</option>
						<option value="4">Izin</option>
						<option value="3">Sakit</option>
					</select>

				</div>
				<div className='w-full h-full py-4'>
					<select id="countries" onChange={(e) => handleValueChange(e, 'totalHari')} value={state.totalHari} class="bg-bg-primary border border-bg-primary text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4 dark:focus:ring-blue-500 dark:focus:border-blue-500">
						<option value={''}>Berapa Hari</option>
						<option value="1">1</option>
						<option value="2">2</option>
						<option value="3">3</option>
						<option value="4">4</option>
					</select>

				</div>
				<div className='flex w-full h-full gap-2 py-4'>
					<Datepicker
						asSingle={true}
						// useRange={false}
						placeholder={"Tanggal Izin"}
						primaryColor={"blue"}
						value={state.date1}
						onChange={(e) => handleValueChange(e, "date1")}
					/>
					<Datepicker
						asSingle={true}
						// useRange={false}
						placeholder={"Tanggal Izin"}
						primaryColor={"blue"}
						value={state.date2}
						onChange={(e) => handleValueChange(e, "date2")}
					/>

				</div>
				<div className='w-full h-full py-4'>
					<label htmlFor="email" className="block text-sm font-semibold leading-6text-black">
						Mohon Berikan Alasan Izin
					</label>
					<div className="mt-2.5">
						<input
							type="text"
							name="reason"
							id="reason"
							placeholder='Alasan'
							className="block w-full rounded-md border-0 px-3.5 py-4 bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
							value={state.reason}
							onChange={(e) => handleValueChange(e, 'reason')}
						/>
					</div>

				</div>
				<div className='w-full px-4 py-8'>
					<div className="flex gap-2">
						<input type="checkbox" id="some_id" onChange={handleOnChange} className="relative w-4 h-4 mt-1 bg-white border-2 rounded-sm appearance-none peer shrink-0 checked:bg-white checked:border-0"
						/>
						<label className='text-sm' htmlFor="some_id">Saya menyetujui semua segala kebijakan dari perusahaan</label>
						<svg
							className="absolute hidden w-4 h-4 mt-1 pointer-events-none peer-checked:block"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							fill="none"
							stroke="#22c55e"
							stroke-width="4"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<polyline points="20 6 9 17 4 12"></polyline>
						</svg>
					</div>
				</div>
				<div className='w-full h-full py-4'>
					<div onClick={setAddIzin} className="block px-8 rounded-full bg-gradient-to-b from-red-light-bg to-orange-bg hover:bg-gradient-to-b hover:from-red-dark-bg hover:to-orange-dark-bg py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
						SIMPAN
					</div>
				</div>


			</div>




		</div >
	)
}

export default AddRencanaIzin